module.exports = __webpack_public_path__ + "fonts/unb_pro_bold.662b0e45.otf";